import { Middleware } from "redux";
import { RootState } from "../../../state";
import { serverRequest } from "../../../actions/app/api";
import { APP_URL, DELETE } from "../../../../_shared/constants";
import { DELETE_USER } from "../../../actions";

export const deleteUser: Middleware<unknown, RootState> =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
    if (action.type === DELETE_USER.START) {
      const { payload, onFinish, ...rest } = action.meta;
      dispatch(
        serverRequest({
          method: DELETE,
          url: `${APP_URL.user.delete}`,
          onFinish,
          payload,
          onSuccess: DELETE_USER.SUCCESS,
          ...rest,
        })
      );
    }
  };
